<template>
  <div v-bind:style="[onRender ? { display: 'contents' } : { display: 'block' }]">
    <tr v-for="(historyData, index) in filteredUserRoleHistory" :key="`${historyData.id}-user-history-${index}`" v-bind:class="{ deactivated: historyData.status === 'Deactivated' }">
      <td :title="historyData.studyName" data-testid="study-name" v-if="checkStringCountCondition(historyData.studyName, 19)">{{ sliceString(historyData.studyName, 17) }}...</td>
      <td v-else data-testid="study-name">{{ historyData.studyName }}</td>
      <td>{{ historyData.userDefinedSiteId }}</td>
      <td v-if="userRole(historyData) == 'Pi'">Principal Investigator</td>
      <td v-if="userRole(historyData) == 'SubPi'">Sub-Investigator</td>
      <td v-if="userRole(historyData) == 'StudyCoordinator'">
        Study Coordinator
      </td>
      <td v-if="userRole(historyData) == 'HomeHealth'">Home Health</td>
      <td v-if="userRole(historyData) == 'CallCenter'">Call Center</td>
      <td v-if="userRole(historyData) == 'Cra'">
        Clinical Research Associate (Blinded)
      </td>
      <td v-if="userRole(historyData) == 'CraUB'">
        Clinical Research Associate (Unblinded)
      </td>
      <td v-if="userRole(historyData) == 'Dm'">Data Manager</td>
      <td v-if="userRole(historyData) == 'Quality'">Quality</td>
      <td v-if="userRole(historyData) == 'SystemAdmin'">Platform Admin</td>
      <td v-if="userRole(historyData) == 'StudyAdmin'">Study Admin</td>
      <td v-if="userRole(historyData) == 'StudyManager'">Study Manager</td>
      <td v-if="userRole(historyData) == 'Rater'">Rater</td>
      <td v-if="userRole(historyData) == 'SiteDataLock'">Site-Data Lock</td>
      <td v-if="userRole(historyData) == 'Interviewer'">Interviewer</td>
      <td v-if="userRole(historyData) == 'Biostatistics'">Biostatistics</td>
      <td v-if="userRole(historyData) == 'Pharmacovigilance'">
        Pharmacovigilance
      </td>
      <td>{{ historyData.status }}</td>
      <td v-if="!historyData.canDataAccessChange" class="text-center">
        <input type="checkbox" class="data-access-checkbox" onclick="return false" :checked="historyData.userDataAccessType == 'LIVE' || historyData.userDataAccessType == 'BOTH'" />
      </td>
      <td v-if="historyData.canDataAccessChange" class="text-center">
        <input type="checkbox" class="data-access-checkbox live-checkbox" @click.stop="" @change.stop="" :checked="historyData.userDataAccessType == 'LIVE' || historyData.userDataAccessType == 'BOTH'" />
      </td>
      <td v-if="!historyData.canDataAccessChange" class="text-center">
        <input type="checkbox" class="data-access-checkbox" onclick="return false" :checked="historyData.userDataAccessType == 'TEST' || historyData.userDataAccessType == 'BOTH'" />
      </td>
      <td v-if="historyData.canDataAccessChange" class="text-center">
        <input type="checkbox" class="data-access-checkbox test-checkbox" @click.stop="" @change.stop="" :checked="historyData.userDataAccessType == 'TEST' || historyData.userDataAccessType == 'BOTH'" />
      </td>
      <td v-if="!isProfile">
        <div class="blinded-container">
          <span class="un-bld-Lbl-Txt">Unblinded</span>
          <label class="switch">
            <input type="checkbox" v-model="historyData.blinded" disabled />
            <div class="slider round"></div>
          </label>
          <span class="bld-Lbl-Txt">Blinded</span>
        </div>
      </td>
      <td v-if="!isProfile">
        <span> </span>
      </td>
    </tr>
  </div>
</template>
<script>
export default {
  name: "userRoleHistoryData",
  props: {
    userRoleHistory: {
      default: () => [],
      type: Array,
      required: false
    },
    isProfile: {
      default: null,
      type: Boolean,
      required: false
    },
    isSiteTeamUser: {
      default: null,
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      onRender: false
    };
  },
  mounted() {
    this.onRender = true;
  },
  computed: {
    // keep only roles with study name
    filteredUserRoleHistory() {
      return this.userRoleHistory.filter(r => r.studyName);
    }
  },
  methods: {
    userRole(data) {
      return data.role;
    },
    checkStringCountCondition(str, count) {
      if (str) {
        return str.length >= count;
      }
    },
    sliceString(str, index) {
      if (str) {
        return str.slice(0, index);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.deactivated {
  color: #666669 !important;
  opacity: 0.5 !important;
  /* & :hover {
            cursor: not-allowed !important;
        } */
  & input[type="checkbox"] {
    opacity: 0.5 !important;
    &:hover {
      pointer-events: none !important;
    }
  }
}
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  top: 0px;
  left: 6px;
}
/* The slider */
.slider {
  position: absolute;
  cursor: not-allowed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
/* Rounded sliders */
.un-bld-Lbl-Txt {
  color: #666669 !important;
  /* opacity: 0.5; */
  position: relative;
  top: -14px;
  right: 1px;
}
.bld-Lbl-Txt {
  color: #666669 !important;
  /* opacity: 0.5; */
  position: relative;
  top: -14px;
  left: 10px;
}
.help_icon {
  color: #b8c7ce;
  border: none !important;
  outline: none !important;
}
.info-msg {
  position: relative;
  left: 13px;
  top: -14px;
}
.Deactivate-from-site-study {
  font-family: Roboto-Regular;
  color: #f16559;
  cursor: not-allowed;
}
.Activate-from-site-study {
  font-family: Roboto-Regular;
  color: #4c8ce4;
  cursor: not-allowed;
}
.table-borderless > tbody > tr > td,
.table-borderless > tbody > tr > th,
.table-borderless > tfoot > tr > td,
.table-borderless > tfoot > tr > th,
.table-borderless > thead > tr > td,
.table-borderless > thead > tr > th {
  border: none !important;
}
.blinded-container {
  min-width: 100px;
}
.data-access-checkbox {
  width: 15px;
  height: 15px;
}
</style>
